export const AuthActionTypes = {
    SET_LOGIN: 'SET_LOGIN',
    SET_LOGOUT: 'SET_LOGOUT',
    CHECK_LOGIN_SUCCESS: 'CHECK_LOGIN_SUCCESS',
    CHECK_LOGIN_FAILURE: 'CHECK_LOGIN_FAILURE',
    SET_LOGGED_IN_DETAILS: 'SET_LOGGED_IN_DETAILS',
    SET_GETTING_GUEST_TOKEN: 'SET_GETTING_GUEST_TOKEN',
    PORTAL_LOCKED: 'PORTAL_LOCKED'
};